import React from 'react';
import Contact from '../components/Contact/Contact';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Contact />
    </div>
  );
};

export default ContactPage;